import { render, staticRenderFns } from "./order-step.vue?vue&type=template&id=62c26f66&scoped=true"
import script from "./order-step.vue?vue&type=script&lang=js"
export * from "./order-step.vue?vue&type=script&lang=js"
import style0 from "./order-step.vue?vue&type=style&index=0&id=62c26f66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c26f66",
  null
  
)

export default component.exports